import { useEffect, useMemo, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { districtGroupCount } from "@/lib/audienceEngine";

const SLOTS = [
  { left: "20%", top: "17%" },
  { left: "64%", top: "11%" },
  { left: "78%", top: "40%" },
  { left: "30%", top: "50%" },
  { left: "74%", top: "80%" },
];

function Corner({ className }) {
  return <span className={`absolute h-1.5 w-1.5 border-[#C6EE5A]/80 ${className}`} aria-hidden="true" />;
}

export function HeroTags() {
  const reduce = useReducedMotion();
  const [tick, setTick] = useState(0);
  const tags = useMemo(
    () => [
      { k: "RG40", v: `${districtGroupCount("RG40", "A02").toLocaleString("en-GB")} Exclusive Enclaves` },
      { k: "Profile", v: "Likely downsizer" },
      { k: "Property", v: "4 bed" },
      { k: "Stage", v: "Pre-retirement" },
      { k: "Signal", v: "Capital release" },
      { k: "RG41", v: `${districtGroupCount("RG41", "B07").toLocaleString("en-GB")} Retirement Aims` },
      { k: "Stage", v: "Retired" },
      { k: "Property", v: "5 bed" },
    ],
    []
  );

  useEffect(() => {
    if (reduce) return undefined;
    const id = setInterval(() => setTick((t) => t + 1), 2300);
    return () => clearInterval(id);
  }, [reduce]);

  const visible = new Set([tick % 5, (tick + 2) % 5, (tick + 3) % 5]);
  const round = Math.floor(tick / 5);

  return (
    <div className="pointer-events-none absolute inset-0" aria-hidden="true">
      <AnimatePresence>
        {SLOTS.map((slot, i) => {
          if (!visible.has(i)) return null;
          const tag = tags[(i + round * 3) % tags.length];
          return (
            <motion.div key={`${i}-${tag.k}-${tag.v}`} className="absolute" style={slot}
              initial={{ opacity: 0, y: 8, filter: "blur(6px)" }} animate={{ opacity: 1, y: 0, filter: "blur(0px)" }} exit={{ opacity: 0, y: -6, filter: "blur(6px)" }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}>
              <div className="relative flex items-center gap-2 rounded-md border border-white/10 bg-[rgba(10,28,14,0.55)] px-3 py-1.5 font-ui text-[10px] font-semibold uppercase tracking-[0.13em] text-white/80 backdrop-blur-md">
                <Corner className="-left-1 -top-1 border-l border-t" />
                <Corner className="-right-1 -top-1 border-r border-t" />
                <Corner className="-bottom-1 -left-1 border-b border-l" />
                <Corner className="-bottom-1 -right-1 border-b border-r" />
                <span className="h-1.5 w-1.5 rounded-full bg-[#C6EE5A] animate-blink" />
                <span className="text-white/50">{tag.k}</span>
                <span className="text-[#C6EE5A]">{tag.v}</span>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
}
